/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Vs_Pr_Wins_1Inputs */

const en_fc_vs_pr_wins_1 = /** @type {(inputs: Fc_Vs_Pr_Wins_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proven at scale: two decades of features and production-grade stability.`)
};

/**
* | output |
* | --- |
* | "Proven at scale: two decades of features and production-grade stability." |
*
* @param {Fc_Vs_Pr_Wins_1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_vs_pr_wins_1 = /** @type {((inputs?: Fc_Vs_Pr_Wins_1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Vs_Pr_Wins_1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_vs_pr_wins_1(inputs)
});
export { fc_vs_pr_wins_1 as "fc.vs.pr_wins.1" }